import { IonButton } from '@ionic/react';
import React from 'react';

import { Icon, Text } from '@/components/memo';
import { useShare } from '@/contexts';
import { link } from 'ionicons/icons';

import './SharePrompt.css';

interface SharePromptProps {
  message?: string | React.ReactNode | null;
}

const SharePrompt: React.FC<SharePromptProps> = ({
  message = (
    <>
      Send your <Text color="primary">booking link</Text> to patients
    </>
  )
}) => {
  const { onShare } = useShare();

  return (
    <div className="share-prompt">
      <div className="share-prompt__message-container">
        <Icon icon={link} className="share-prompt__icon" />
        <p className="share-prompt__message">{message}</p>
      </div>
      <IonButton
        className="share-prompt__button"
        onClick={onShare}
        strong={true}
      >
        <div className="share-prompt__button-content">
          <p>Send</p>
        </div>
      </IonButton>
    </div>
  );
};

export default SharePrompt;
